import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { store } from '@/store';
import { router } from '@/router';

import AuthWrapper from '@/components/auth/AuthWrapper';
import SocketAuthSync from '@/components/auth/SocketAuthSync';

export default function App() {
  return (
    <Provider store={store}>
      <AuthWrapper>
        <SocketAuthSync />
        <RouterProvider router={router} />
      </AuthWrapper>
    </Provider>
  );
}
